import React from 'react';
import UIComponent from './ui_component.js';
import { withStyles } from 'material-ui/styles';
import Toolbar from 'material-ui/Toolbar';

const styles = [];

class UIToolbar extends UIComponent {
  constructor() {
    super();
    this.state = {
    }
  }

  getDefaults(){
    const defaults = {
      className : '',      
    }    
    return defaults;
  }
  
  componentDidMount() {

  }
  
  render() {
    return (
      <Toolbar>
        {this.props.children}
      </Toolbar>
    );
  }
}

export default withStyles(styles)(UIToolbar);


// WEBPACK FOOTER //
// ./src/core/ui/toolbar.js